module.exports = __webpack_public_path__ + "0eb170b369cadb5fa79c7bd5cfa4786b.svg";